//<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
export default function addMaterialIcons() {
  const tag = document.createElement("link")
  tag.setAttribute(
    "href",
    "https://fonts.googleapis.com/icon?family=Material+Icons"
  )
  tag.setAttribute("rel", "stylesheet")
  document.getElementsByTagName("head")[0].appendChild(tag)
}
